module.exports = __webpack_public_path__ + "media/widget/v2/assets/image/main-a5c588deddba37c95d75f7e1290bff2e.svg";